import { render, staticRenderFns } from "./EditOfflineEmployee.vue?vue&type=template&id=72418c28&"
import script from "./EditOfflineEmployee.vue?vue&type=script&lang=js&"
export * from "./EditOfflineEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports